import PostForm from "../../../../frontend/js/postform";
import Analytics from "../../../../frontend/js/analytics.js";

class ProductsList {
    constructor() {
        this.poster = new PostForm();
        this.setupForms();
        this.addEventListeners();
    }

    setupForms() {
        var forms = document.querySelectorAll(".product-list__item__cta-container form");
        forms.forEach(function (form) {
            var actionUrl = form.getAttribute("action");
            if (!actionUrl.endsWith("/")) {
                actionUrl += "/";
            }
            form.setAttribute("action", actionUrl + "addtocart");
        });
        const updateUrlFunction = this.getUpdateUrl;
        const updateButtons = document.querySelectorAll(".order__amount-form .cart-update-button");
        updateButtons.forEach(function (button) {
            button.addEventListener("click", async function (e) {
                e.preventDefault();
                e.stopPropagation();
                const form = button.closest("form");
                if(!form) {
                    console.error("No form found for button", button);
                    return;
                }
                
                const formData = new FormData(form);
                const requesturl = updateUrlFunction();
                console.log("Sending request to", requesturl);
                const request = await fetch(requesturl, {
                    method: "POST",
                    body: formData
                });
                
                const {total, price} = await request.json();
                
                if(!!total) {
                    const container = form.querySelector('.order-form__table');
                    const totalItems = container.querySelector('.order-amount-total');
                    const totalPrice = container.querySelector('.sum-total');
                    totalItems.innerHTML = total;
                    totalPrice.innerHTML = price + " kr";
                }
            });
        });
    }
    
    getUpdateUrl() {
        let baseUrl = new URL(window.location.href).pathname;
        if(baseUrl.endsWith("/")) {
            baseUrl = baseUrl.substring(0, baseUrl.length - 1);
        }
        return baseUrl + "/addtocart";
    }

    addEventListeners() {
        var forms = document.querySelectorAll(".product-list__item__cta-container form");
        forms.forEach(function (form) {
            form.addEventListener("submit", function (e) {
                e.preventDefault();
                PostForm.postForm(form,
                    function (response) {
                        var data = JSON.parse(response);
                        document.querySelector("#product-cart span").innerHTML = data.total;
                    },
                    function (response) {
                        console.log("error", response);
                    }
                );
            });
        });

        // if (typeof $$epiforms !== 'undefined') {
        //     $$epiforms(document).ready(function myfunction() {                
        //         $$epiforms(".product-list__wrapper .formBlock").on("formsSubmitted", evt => {
        //             Analytics.orderForm();
        //         });
        //     });
        // }

    }


}
document.addEventListener("DOMContentLoaded", function () {
    new ProductsList();
});